import Chart from "react-apexcharts";
import React from "react";

const ScatterChart = ({ chartUtils, chartinfo, colors }) => {
  const options = {
    chart: {
      type: "scatter",
      zoom: {
        enabled: true,
        type: "xy",
      },
    },
    xaxis: {
      categories: chartUtils?.category || [],
    },
    markers: {
      size: 5,
    },
    yaxis: {
      labels: {
        formatter: (value) => value.toFixed(2),
      },
    },
  };

  return (
    <Chart
      options={options}
      series={chartUtils?.series || []}
      type="scatter"
      height={350}
      width={"100%"}
    />
  );
};

export default ScatterChart;
